import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import ButtonSec from './ButtonSec';
import LinkButton from './LinkButton';

  const Menu = ({ textVariable }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
  
    const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
    };

  return (
    <div className="flex py-4">
      <div className='w-full'>
        <div className='flex items-center animate__animated animate__fadeInLeft animate__delay-0.5s'>
          <ButtonSec onClick={toggleMenu}>
            <FontAwesomeIcon icon={faBars} className="text-slate-50" />
          </ButtonSec>
          <p className='text-xl md:text-xl lg:text-2xl text-slate-50 text-right animate__animated animate__fadeInRight animate__delay-2.5s'>{textVariable}</p>
        </div>
      {isMenuOpen && (
        <div className='flex flex-col md:flex-row'>
          <div>
            <Link to="/"><ButtonSec size="text-m md:text-m lg:text-xl"><FontAwesomeIcon className='text-l' icon={faCaretRight}/>&emsp;Start</ButtonSec></Link>
          </div>
          <div>
            <Link to="/characters"><ButtonSec size="text-m md:text-m lg:text-xl"><FontAwesomeIcon icon={faCaretRight}/>&emsp;Characters</ButtonSec></Link>
          </div>
          <div>
            <Link to="/comics"><ButtonSec size="text-m md:text-m lg:text-xl"><FontAwesomeIcon icon={faCaretRight}/>&emsp;Comics</ButtonSec></Link>
          </div>
          <div>
            <Link to="/series"><ButtonSec size="text-m md:text-m lg:text-xl"><FontAwesomeIcon icon={faCaretRight}/>&emsp;Series</ButtonSec></Link>
          </div>
          <div>
            <Link to="/events"><ButtonSec size="text-m md:text-m lg:text-xl"><FontAwesomeIcon icon={faCaretRight}/>&emsp;Events</ButtonSec></Link>
          </div>
        </div>
      )}
      </div>
      <div className='flex justify-end animate__animated animate__fadeInRight animate__delay-2.5s'>
        <Link to={`/`}><img className='p-2' onClick={toggleMenu} src="/images/logo/mv_app_logo_mini.png" alt="mv-logo-app_mini"/></Link>
      </div>
    </div>
  );
};

export default Menu;
